import React from "react";
import Skeleton from "react-loading-skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";

/**
 * Generic Table Skeleton component
 * @param {Object} props
 * @param {Array} props.columns - Array of column configurations
 *   - header: React node for header
 *   - width: width of main skeleton
 *   - height: height of main skeleton
 *   - className: className for TableCell and TableHead
 *   - renderSkeleton: custom render function for the cell content
 *   - subSkeleton: object with { width, height } for a secondary skeleton below the main one
 * @param {number} props.rows - Number of rows to display (default 5)
 * @param {string} props.className - Additional className for the Table
 */
export default function TableSkeleton({ columns, rows = 5, className = "" }) {
  return (
    <Table className={className}>
      <TableHeader className="bg-slate-50">
        <TableRow>
          {columns.map((col, i) => (
            <TableHead key={i} className={col.className}>
              {col.header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((col, colIndex) => (
              <TableCell key={colIndex} className={col.className}>
                {col.renderSkeleton ? (
                  col.renderSkeleton()
                ) : (
                  <div className="flex flex-col">
                    <Skeleton 
                      width={col.width || 80} 
                      height={col.height || 20} 
                      circle={col.circle}
                      borderRadius={col.borderRadius}
                    />
                    {col.subSkeleton && (
                      <div className="mt-1">
                        <Skeleton 
                          width={col.subSkeleton.width || 60} 
                          height={col.subSkeleton.height || 12} 
                        />
                      </div>
                    )}
                  </div>
                )}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
